import { Fragment, useEffect, useState } from "react";
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Table,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import { useSelector } from "react-redux";
import { getRequestListAxios } from "../Actions/v1/user";
import { FaEdit } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../Layout/Footer";
import Header from "../Layout/Header";
import Images from "../Images";
import { getFormsAxios } from "../Actions/v1/admin";




function RequestList() {
  const navigate = useNavigate();
  const location = useLocation();

  const { account } = useSelector((state) => state?.user);
  const [assetList, setAssetList] = useState([]);
  const [type, setType] = useState("exchange");
  const [sectiontype, setSectiontype] = useState("");
  const [FormLists, setFormLists] = useState([]);
  console.log("exchangeListsexchangeLists", FormLists);

 const [visibleCount, setVisibleCount] = useState(10); // For "load more"


  const { goBackSectionType } = location.state || "exchange";
  console.log("goBackSectionType", goBackSectionType)
  const getFormListsList = async (type) => {
    console.log("typepepepepep", type)
    const sectionType = type ? type : goBackSectionType ? goBackSectionType : "exchange";
    setType(sectionType)
    let resp = await getFormsAxios({ section: sectionType ? sectionType : {} });
    console.log("🚀 ~ FffLists ~ resp:", resp);
    if (resp?.status) {
      setFormLists(resp?.data?.data);
       setVisibleCount(10);
    }
  };

  // const getRequestsList = async () => {
  //   let resp = await getRequestListAxios({
  //     emailid: account.EmailId,
  //     type,
  //   });
  //   console.log("🚀 ~ getRequestsList ~ resp:", resp);
  //   if (resp?.status) {
  //     setAssetList(resp?.data);
  //   }
  // };

  console.log("assetList-->", assetList);

  useEffect(() => {
    // getRequestsList();
    getFormListsList()
  }, []);

  
   const handleLoadMore = () => {
    setVisibleCount((prev) => prev + 8);
  };

  const visibleItems = FormLists.slice(0, visibleCount);
  
  return (
    <>
      <div>
        <div>
          <Header />
          <div className="inner_page position-relative ">
            <img src={Images.elogo} className="elogo" alt="elogo" />
            <img
              src={Images.smallround}
              className="smallround_footer"
              alt="round"
            />
            <Container className="mt-5 pb-5">
              <h4 className="pb-3">List your form Request</h4>
              <Row className="mb-4">
                <Col lg={6} xl={4} className="me-auto">
                  <Dropdown
                    className="reqdrop"
                    onSelect={(e) => {
                      setType(e);
                    }}
                  >
                    <Dropdown.Toggle
                      className="w-100 text-start"
                      variant="success"
                      id="dropdown-basic"
                    >
                      {type == "" ? "Select Type" : type}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="w-100">
                      {["coin", "exchange"]?.map((val) => (
                        <Dropdown.Item eventKey={val} onClick={() => { getFormListsList((val).toString().toLowerCase()) }}>{val}</Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </Col>
              </Row>

              <Table responsive className="fulllist text-center">
                <thead>
                  <tr>
                    <th>S.no</th>
                    <th>Name of Project</th>
                    <th>Email</th>
                    <th>Status</th>
                    <th>Edit</th>
                  </tr>
                </thead>
                
                <tbody>

               {visibleItems.length > 0 ? (
                  visibleItems.map((val, index) => (
                    <tr
                          key={index}
                          // onClick={()=>handleClick(item.tokenId)}
                          className="listing_coin"
                        >
                          <td>{index + 1}</td>
                          <td>
                            <span className="fw-500">
                              {val.projectType}
                            </span>{" "}
                            {/* <span className="shortname">
                            {val.application.symbol}
                          </span> */}
                          </td>
                          <td className="fw-500">{val.email ? val.email : "null"}
                          </td>
                          <td 
                           style={{ color: val.status === "approved" ? "green" : "red" }}
                          className="fw-500 text-capitalize"
                           >{val.status ? val.status  : "null"}</td>
                          <td>
                            {val.status == "approved" ? (
                              <Fragment>
                                <button
                                  className={`themebtn rounded-1 py-2  ${val._id}`}
                                  onClick={() =>
                                    navigate("/viewformdetails", {
                                      state: {
                                        records: val,
                                        sectionType: type
                                      }
                                    }
                                    )
                                  }
                                >
                                  <FaEdit />
                                </button>
                              </Fragment>
                            ) : (
                              <Fragment>
                                <button
                                  className={`themebtn rounded-1 py-2  ${val._id}`}
                                  onClick={() =>
                                    navigate("/viewformdetails", {
                                      state: {
                                        records: val,
                                        sectionType: type
                                      }
                                    }
                                    )
                                  }
                                >
                                  <FaEdit />
                                </button>
                              </Fragment>
                            )}
                          </td>
                    </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan={5}><h5 className="py-4">No Data Found</h5></td>
                  </tr>
                )}



            
              
                </tbody>
              </Table>

                {/* Load More Button */}
            {visibleCount < FormLists.length && (
              <div className="text-center mt-3">
                <button className="themebtn themehoverbtn rounded-1 fbtn py-2 px-3 fw-600" onClick={handleLoadMore}>
                  Load More
                </button>
              </div>
            )}

            </Container>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default RequestList;
